<template>
  <button
    ref="buttonRef"
    data-tooltip-text="Prevent non-owners from editing"
    data-tooltip-position="below"
    :class="{
      MenuButton: true,
      'm-locked': value,
    }"
    v-on:click="onClick"
  >
    <img
      :src="'/img/icons/lock-open-outline-white.svg'"
      v-if="!value"
      :class="{ 'm-full-size': !value }"
    />
    <img :src="'/img/icons/lock-closed-outline-white.svg'" v-if="value" />
    <span v-if="value">Locked</span>
  </button>
</template>

<script lang="ts">
import { Component, Prop, Ref, Vue } from "vue-property-decorator";
import { addTooltip } from "./tooltip";
import Countdown from "@/components/Countdown.vue";

@Component({ components: { Countdown } })
export default class TwoStateIconButton extends Vue {
  @Prop() readonly value!: boolean;
  @Prop() readonly onClick!: () => void;

  @Ref() readonly buttonRef!: HTMLButtonElement;

  mounted() {
    addTooltip(this.buttonRef);
  }
}
</script>

<style scoped lang="scss">
.MenuButton {
  &.m-locked {
    background-color: var(--error) !important;
  }
}
</style>
